import React from 'react'
import AddExpense from './AddExpense'

const Expense = () => {
  return (
    <div className='px-4 py-2'>
      <AddExpense/>
    </div>
  )
}

export default Expense;